import { render, staticRenderFns } from "./SubscriptionExpiringBar.vue?vue&type=template&id=1dac820e&scoped=true&"
import script from "./SubscriptionExpiringBar.vue?vue&type=script&lang=js&"
export * from "./SubscriptionExpiringBar.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionExpiringBar.vue?vue&type=style&index=0&id=1dac820e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac820e",
  null
  
)

export default component.exports